// One label per property change request type. Pure (no imports), so the
// Tasks loader can read it under node as well as in the app.
export const REQUEST_LABELS = {
  add: "New Property",
  edit: "Edit Property",
  delete: "Delete Property",
  delete_tenant: "Archive Tenant",
  terminate_lease: "Terminate Lease",
  archive_owner: "Archive Owner",
  delete_autopay: "Delete Autopay",
  disable_autopay: "Pause Autopay",
  move_out: "Move-Out",
  deposit_change: "Change Deposit",
};
